import { Partner } from 'src/modules/designStudio/helpers/Partner';
import { ProductTypeLabel } from 'src/modules/designStudio/helpers/productSelection/types';

/**
 * This structure associates the providers/brands that partners support.
 * For example:
 *
 * James Hardie embeds design-studio in its website, and we also have an org for JH homeowners(homeowners who
 * hover'd their house through the JH website). The Partner enum keeps track of whether design-studio is
 * being shown in either JH guest mode, or as part of the JH org. In this case we only want to show JH products,
 * and JH products belong to the JH provider(ID: 1).
 *
 * As more partners want this functionality of filtering out products we can add the provider id's they support here.
 */
export const ProvidersByPartner: Record<Partner, string[] | undefined> = {
  [Partner.DEFAULT]: undefined,
  [Partner.JAMES_HARDIE]: ['1'],
  [Partner.MUELLER]: [
    '9',
    '59',
    '1745',
    '8532',
    '1749',
    '8',
    '1',
    '57',
    '15',
    '5',
    '11',
    '8705',
    '12',
    '7',
    '6',
    '389',
    '3',
    '5839',
    '58',
    '906',
    '1756',
    '8502',
    '2',
    '8485',
  ],
  [Partner.AMERIPRO]: ['16', '4', '8', '1', '5', '7', '389', '8502'],
  [Partner.HANSONS]: ['8', '291', '8806', '8514', '389'],
  [Partner.INFINITY]: [
    '14',
    '1201',
    '8',
    '1',
    '15',
    '5',
    '12',
    '389',
    '425',
    '5839',
  ],
  [Partner.ABC_SEAMLESS]: ['13'],
  [Partner.PRIDDY]: ['54', '4', '14'],
  [Partner.PRIDDY_JH]: ['1'],
  [Partner.WINDOWS_ROYAL]: ['58'],
  [Partner.WINDOWS_CERTAINTEED]: ['14'],
  [Partner.EXTERIORS_COMPANY]: ['4', '15', '12', '1', '14'],
  [Partner.B_B_SIDING]: [
    '1',
    '9',
    '12',
    '14',
    '15',
    '58',
    '1749',
    '4',
    '8705',
    '54',
  ],
};

export type ProductTypePreference =
  | 'REAL'
  | 'REAL_WITH_GENERIC_FALLBACK'
  | 'GENERIC'
  | 'NONE';

export type PartnerProductPreference = Record<
  ProductTypeLabel,
  ProductTypePreference
>;

export const PartnerProductsRouterConfig: Record<
  Partner,
  PartnerProductPreference | ProductTypePreference
> = {
  [Partner.DEFAULT]: 'REAL_WITH_GENERIC_FALLBACK',
  [Partner.JAMES_HARDIE]: {
    [ProductTypeLabel.HORIZONTAL_SIDING]: 'REAL',
    [ProductTypeLabel.VERTICAL_SIDING]: 'REAL',
    [ProductTypeLabel.SHINGLED_SIDING]: 'REAL',
    [ProductTypeLabel.BRICK_SIDING]: 'NONE',
    [ProductTypeLabel.STONE_SIDING]: 'NONE',
    [ProductTypeLabel.CONCRETE_SIDING]: 'NONE',
    [ProductTypeLabel.STUCCO_SIDING]: 'NONE',
    [ProductTypeLabel.SHINGLE_ROOF]: 'GENERIC',
    [ProductTypeLabel.TILE_ROOF]: 'GENERIC',
    [ProductTypeLabel.METAL_ROOF]: 'GENERIC',
    [ProductTypeLabel.TRIM]: 'REAL',
  },
  [Partner.MUELLER]: 'REAL_WITH_GENERIC_FALLBACK',
  [Partner.AMERIPRO]: 'REAL_WITH_GENERIC_FALLBACK',
  [Partner.HANSONS]: 'REAL_WITH_GENERIC_FALLBACK',
  [Partner.INFINITY]: 'REAL_WITH_GENERIC_FALLBACK',
  [Partner.ABC_SEAMLESS]: 'REAL_WITH_GENERIC_FALLBACK',
  [Partner.PRIDDY]: 'REAL_WITH_GENERIC_FALLBACK',
  [Partner.PRIDDY_JH]: 'REAL_WITH_GENERIC_FALLBACK',
  [Partner.WINDOWS_ROYAL]: 'REAL_WITH_GENERIC_FALLBACK',
  [Partner.WINDOWS_CERTAINTEED]: 'REAL_WITH_GENERIC_FALLBACK',
  [Partner.EXTERIORS_COMPANY]: 'REAL_WITH_GENERIC_FALLBACK',
  [Partner.B_B_SIDING]: 'REAL_WITH_GENERIC_FALLBACK',
};
